// Definizione centralizzata delle voci di menu con chiavi per i permessi di visibilità.
// roles: null = tutti i ruoli; altrimenti lista ruoli abilitati (admin passa sempre il gate ruolo).
export const MENU_DEFS = [
  { key: "dashboard", path: "/", label: "Dashboard", roles: null },
  { key: "mia_agenda", path: "/mia-agenda", label: "La mia agenda", roles: ["admin", "responsabile", "supervisore"] },
  { key: "clienti", path: "/clienti", label: "Clienti", roles: null },
  { key: "commesse", path: "/commesse", label: "Commesse", roles: null },
  { key: "prodotti", path: "/prodotti", label: "Prodotti", roles: null },
  { key: "magazzino", path: "/magazzino", label: "Magazzino", roles: null },
  { key: "calendario", path: "/calendario", label: "Calendario", roles: null },
  { key: "chat", path: "/chat", label: "Comunicazioni", roles: null },
  { key: "installazioni_da_pianificare", path: "/installazioni-da-pianificare", label: "Installazioni da Pianificare", roles: ["admin", "operatore"] },
  { key: "interventi_da_pianificare", path: "/interventi-da-pianificare", label: "Interventi da Pianificare", roles: ["admin", "operatore", "tecnico"] },
  { key: "progetti_3d", path: "/progetti-3d", label: "Progetti FV", roles: ["admin", "operatore", "tecnico"] },
  { key: "miei_canali", path: "/miei-canali", label: "I miei canali", roles: null },
  { key: "itinerario", path: "/itinerario", label: "Itinerario", roles: null },
  { key: "pianificazione_interventi", path: "/pianificazione-interventi", label: "Pianif. interventi", roles: null },
  { key: "veicoli", path: "/veicoli", label: "Veicoli Aziendali", roles: ["admin", "operatore"] },
  { key: "reports", path: "/reports", label: "Reports", roles: ["admin", "operatore", "magazzino"] },
  { key: "analytics", path: "/analytics", label: "Analytics", roles: ["admin"] },
  { key: "squadre", path: "/squadre", label: "Squadre", roles: ["admin"] },
  { key: "utenti", path: "/utenti", label: "Utenti", roles: ["admin"] },
  { key: "audit_logs", path: "/audit-logs", label: "Log attività", roles: ["admin"] },
  { key: "aruba_jobs", path: "/aruba-jobs", label: "Aruba Drive · Job", roles: ["admin"] },
  { key: "whatsapp_settings", path: "/whatsapp-settings", label: "WhatsApp", roles: ["admin"] },
  { key: "admin_errors", path: "/admin/errors", label: "Errori 5xx", roles: ["admin"] },
  { key: "impostazioni", path: "/impostazioni", label: "Impostazioni", roles: ["admin"] },
  { key: "dico", path: "/clienti", label: "DiCo — Dich. Conformità (scheda cliente)", roles: ["admin", "operatore"] },
];

// Voci "opt-in": per i ruoli non-admin sono visibili SOLO se il super admin le ha
// abilitate esplicitamente nei permessi menu dell'utente (menu_permissions).
export const OPT_IN_MENU_KEYS = ["installazioni_da_pianificare", "dico"];

export function canSeeMenu(user, key) {
  if (!user) return false;
  if (key === "mia_agenda") return ["admin", ...FIELD_ROLES].includes(user.role);
  if (key === "chat" && FIELD_ROLES.includes(user.role)) return true;
  if (user.is_super) return true;
  const p = user.menu_permissions;
  if (OPT_IN_MENU_KEYS.includes(key) && user.role !== "admin") {
    return p != null && p.includes(key);
  }
  return p == null || p.includes(key);
}

// Azioni gated dentro le pagine (permessi separati dalle voci menu)
export const ACTION_DEFS = [
  { key: "clienti_delete", label: "Eliminare clienti" },
  { key: "commesse_delete", label: "Eliminare commesse" },
  { key: "prodotti_delete", label: "Eliminare prodotti" },
  { key: "economico_view", label: "Vedere sezione Economico", adminOnly: true },
  { key: "pdf_generate", label: "Generare PDF" },
  { key: "export_data", label: "Esportare dati (Excel/PDF)" },
];

export function canDoAction(user, key) {
  if (!user) return false;
  if (user.is_super) return true;
  const p = user.action_permissions;
  return p == null || p.includes(key);
}

// Ruoli "sul campo" (supervisore squadre / responsabile squadra):
// sopralluogo in sola lettura, compilano installazione/interventi, niente costi/PDF/link.
export const FIELD_ROLES = ["supervisore", "responsabile"];
export function isFieldRole(user) {
  return FIELD_ROLES.includes(user?.role);
}

export function roleAllows(user, def) {
  return !def.roles || def.roles.includes(user?.role) || user?.role === "admin";
}

// Prima pagina raggiungibile dall'utente (per redirect quando una voce è bloccata).
export function firstAllowedPath(user) {
  const d = MENU_DEFS.find((m) => roleAllows(user, m) && canSeeMenu(user, m.key));
  return d ? d.path : null;
}
